import { rowColumn } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";

export const applicationsListTable = (currPath: string, assessors: any): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "firstName",
    type: "string",
    allowSort: true,
    sortOn: "FirstName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Last Name",
    column: "lastName",
    type: "string",
    allowSort: true,
    sortOn: "LastName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Kindergarten",
    column: "fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "FundedKinderName",
    body: (rowData) => {
      return <p className="m-0">{rowData.fundedKinderName === "Other" ? rowData.kindergartenNameOther : rowData.fundedKinderName}</p>;
    },
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Assigned Assessor",
    column: "assignedAssessorName",
    type: "string",
    allowSort: true,
    sortOn: "AssignedAssessorName",
    isFilter: true,
    filterType: "multiselect",
    filterElements: assessors,
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions([assignStatusPrimaryOptions.find((x) => x.value === "Application")], assignStatusSecondaryOptions, [
      { secondaryOption: "Presubmission" },
    ]),
  },
  {
    label: "Date Submitted",
    column: "dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "DateSubmitted",
  },
  {
    label: "KPI",
    column: "kpi",
    type: "number",
    allowSort: true,
    sortOn: "KPI",
    isDefaultSortColumn: true,
    defaultSortDirection: "asc",
    body: (rowData) => {
      let kpiStatusColor = "";
      const kpiValue = rowData.kpi;
      if (kpiValue == 4 || kpiValue == 3) {
        kpiStatusColor = "kpi-status kpi-green";
      } else if (kpiValue == 2) {
        kpiStatusColor = "kpi-status kpi-yellow";
      } else if (kpiValue == 1) {
        kpiStatusColor = "kpi-status kpi-orange";
      } else if (kpiValue != null && kpiValue <= 0) {
        kpiStatusColor = "kpi-status kpi-red";
      } else {
        kpiStatusColor = "kpi-status border-transparent";
      }
      return (
        <span className={kpiValue != null ? `${kpiStatusColor}` : "kpi-status border-transparent"}>
          {kpiValue != null || kpiValue != undefined ? kpiValue : "—"}
        </span>
      );
    },
  },

  {
    label: "Actions",
    body: (rowData) => <a href={`${currPath}/${rowData.discriminator}/${rowData.id}`}>View Details</a>,
  },
];
